export default __webpack_public_path__ + "7e3ea1a3dd1dd95cc710fd6e20213c45.png";